import ClearIcon from '@mui/icons-material/Clear'
import TableCell from '@mui/material/TableCell'
import Tooltip from '@mui/material/Tooltip'
import { alpha } from '@mui/material/styles'

import type { GeblokkeerdeWeek } from '../../../planning/types/GeblokkeerdeWeek'
import type { HoofdleidingProject } from '../../project/types/HoofdleidingProject'
import {
  type GeblokkeerdeWekenIndex,
  type YearWeek,
  findGeblokkeerdeWeek,
  planningProcesstapDict,
} from '../util/planning-util'

export { BalkenplanningProjectRange }

const BLOCKED_BACKGROUND_OPACITY = 0.3

type Props = {
  project: HoofdleidingProject
  activeCols: YearWeek[]
  geblokkeerdeWeken: GeblokkeerdeWekenIndex
}

const BalkenplanningProjectRange = ({
  project,
  activeCols,
  geblokkeerdeWeken,
}: Props) => {
  const color = planningProcesstapDict.find(
    ({ label }) => label === project.statusText,
  )?.color

  const getBackground = (blocked?: GeblokkeerdeWeek) => {
    if (!color) return 'transparent'

    return blocked ? alpha(color, BLOCKED_BACKGROUND_OPACITY) : color
  }

  return (
    <>
      {activeCols.map((yearWeek) => {
        const [year, week] = yearWeek
        const blocked = findGeblokkeerdeWeek(
          geblokkeerdeWeken,
          yearWeek,
          project,
        )

        return (
          <TableCell
            key={`${year}-${week}`}
            sx={{
              background: getBackground(blocked),
              ...(blocked && { p: 0, verticalAlign: 'middle' }),
            }}
          >
            {blocked && (
              <Tooltip
                title={`Week ${week} van ${year} is geblokkeerd in gebied ${blocked.gebiedscodeLabel}`}
              >
                <ClearIcon
                  color="error"
                  sx={{ display: 'block', mx: 'auto', cursor: 'not-allowed' }}
                />
              </Tooltip>
            )}
          </TableCell>
        )
      })}
    </>
  )
}
